module.exports = __webpack_public_path__ + "img/cover-fiat-2012-calendar-teaser.2b082c8b.jpg";